import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import validate from './validate';

export default class ValidatedField extends React.Component {
  static propTypes = {
    errorMessages: PropTypes.shape({}).isRequired,
    name: PropTypes.string.isRequired,
    schema: PropTypes.shape({}).isRequired,
  };

  validate = val => validate(val, this.props.name, this.props.schema, this.props.errorMessages);

  render() {
    return (
      <Field
        {...this.props}
        validate={this.validate}
      />
    );
  }
}
